'use strict'

import Storage from 'store'
import { AES, enc as CryptoENC } from 'crypto-js'
import config from '../../config'
import * as api from '../../libs/api/user'
import { LOGIN, LOGOUT } from '../mutation-types'
import { deepClone } from '../../libs/util'

// initial state
const initialState = {
  payload: null,
  token: null,
  isFetching: false,
  error: ''
}

// getters
const getters = {
  token: state => state.token,
  user: state => state.payload,
  userMeta: state => ({
    isFetching: state.isFetching,
    error: state.error
  })
}

const handleLoginResponse = commit => (error, { user, token } = {}) => {
  if (error) {
    commit(LOGIN.FAILURE, { error: error.message || error })
  } else {
    Storage.set(config.storageKeys.user, AES.encrypt(JSON.stringify({ user, token }), config.secret).toString())
    commit(LOGIN.SUCCESS, { user, token })
  }
}
// actions
const actions = {
  login ({ commit }, { user, password, remember }) {
    commit(LOGIN.REQUEST)
    api.login({ user, password, remember }, handleLoginResponse(commit))
  },
  logout ({ commit, rootState }) {
    Storage.clearAll()
    commit(LOGOUT)
  }
}

// mutations
const mutations = {
  [LOGIN.REQUEST] (state) {
    state.isFetching = true
    state.error = null
  },
  [LOGIN.SUCCESS] (state, { user, token }) {
    state.payload = user
    state.token = token
    state.isFetching = false
    state.error = null
  },
  [LOGIN.FAILURE] (state, { error }) {
    state.isFetching = false
    state.error = error
  },
  [LOGOUT] (state) {
    state.isFetching = false
    state.error = null
    state.payload = null
    state.token = null
  },
  [LOGIN.CHECK] (state) {
    const user = Storage.get(config.storageKeys.user)
    if (user) {
      try {
        const decrypt = JSON.parse(AES.decrypt(user, config.secret).toString(CryptoENC.Utf8))
        state.payload = decrypt.user
        state.token = decrypt.token
      } catch (err) {
        console.warn('failed to decrypt user:', err.message)
        Storage.remove(config.storageKeys.user)
      }
    }
  }
}

export default {
  state: deepClone(initialState),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js